import { CvExamInputDto } from '@/shared/cv/cv.dto';
import { EsCvExam } from '@/shared/cv/cv.es.dto';
import { toFormat } from '@/lib/utils/formatters';

export function buildExamFormDefaultValues(
  langId: number,
  exam?: EsCvExam
): CvExamInputDto {
  if (!exam) {
    return {
      langId,
      title: '',
      rate: '',
      startDate: '',
    };
  }

  return {
    id: exam.id,
    langId,
    title: exam.title ?? '',
    rate: exam.rate ?? '',
    startDate: toFormat(exam.startDate),
    companyId: exam.com?.id,
  };
}

export function mapExamFormToPayload(
  data: CvExamInputDto,
  langId: number,
  examId?: number
): CvExamInputDto {
  return {
    ...data,
    ...(examId ? { id: examId } : {}),
    langId,
  };
}

export function getExamFormTitle(isUpdate: boolean, isMn: boolean): string {
  if (isUpdate) {
    return isMn ? 'Шалгалтын оноо засах' : 'Edit score';
  }
  return isMn ? 'Шалгалтын оноо нэмэх' : 'Add score';
}
